import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import ExerciseProgressionGraph from './ExerciseProgressionGraph';

interface ExerciseProgressionDialogProps {
  exerciseId: string | null;
  exerciseName: string;
  initialMode?: 'overload' | 'hypertrophy';
  onClose: () => void;
}

export default function ExerciseProgressionDialog({
  exerciseId,
  exerciseName,
  initialMode = 'overload',
  onClose,
}: ExerciseProgressionDialogProps) {
  return (
    <Dialog open={!!exerciseId} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-lg w-full bg-background border-border p-4 sm:p-6">
        <DialogHeader className="mb-3">
          <DialogTitle className="font-mono text-xs uppercase text-muted-foreground tracking-wider">
            Exercise Progression
          </DialogTitle>
        </DialogHeader>
        {exerciseId && (
          <ExerciseProgressionGraph
            exerciseId={exerciseId}
            exerciseName={exerciseName}
            initialMode={initialMode}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
